import React from 'react';
import { Checkbox } from '@naf-simba/elements-checkbox';
import { Controller } from 'react-hook-form';
import xor from 'lodash/xor';
import type { AddonFormMember } from '../Addons.utils';
import S from './Styles';
import { AddonProductFormFields } from './AddonProductFormFields';
import { AddonProductVariantProps } from './AddonProductField.types';

interface HouseholdPaymentProductFieldProps extends AddonProductVariantProps {
  members: AddonFormMember[];
}

export const HouseholdPaymentProductField = ({
  product,
  members,
  selectedMembers,
  storedMembers,
  control,
  errors,
  watch,
  setValue,
}: HouseholdPaymentProductFieldProps) => (
  <S.FieldWrapper $error={!!errors[product.productNumber]}>
    <Controller
      name={`${product.productNumber}.members`}
      control={control}
      defaultValue={storedMembers || []}
      render={({ field: { value, onChange } }) => (
        <Checkbox
          label={product.productName}
          name={product.productName}
          checked={value.length === members.length}
          onChange={() =>
            onChange(
              xor(
                value as string[],
                Array.from(members.keys(), (index) => index.toString()),
              ),
            )
          }
        />
      )}
    />
    {!!selectedMembers?.length && (
      <AddonProductFormFields product={product} control={control} errors={errors} watch={watch} setValue={setValue} />
    )}
  </S.FieldWrapper>
);
